import { useEffect, useRef } from 'react';
import pick from 'lodash/pick';
const getCallbackValue = (hasSupport, e)=>{
    if (!hasSupport) {
        return {
            offsetLeft: 0,
            offsetTop: 0,
            height: document.documentElement.clientHeight,
            width: document.documentElement.clientWidth,
            scale: 1,
            pageLeft: 0,
            pageTop: 0
        };
    }
    if (e) {
        // We don't send the object back because in IOS the reference became always equal
        // and then clientcode would not update like they expected
        return pick(e.target, [
            'offsetLeft',
            'offsetTop',
            'pageLeft',
            'pageTop',
            'width',
            'height',
            'scale'
        ]);
    }
    return window.visualViewport;
};
export function useVisualViewport(onViewportUpdate, enabled = true) {
    const pendingUpdate = useRef(false);
    const supportsVisualViewport = typeof window !== 'undefined' && typeof window.visualViewport !== 'undefined';
    useEffect(()=>{
        if (supportsVisualViewport && enabled) {
            onViewportUpdate(window.visualViewport);
        }
    }, [
        onViewportUpdate,
        supportsVisualViewport,
        enabled
    ]);
    // The real api
    useEffect(()=>{
        if (!supportsVisualViewport || !enabled) {
            return;
        }
        const viewportHandler = (e)=>{
            if (pendingUpdate.current) {
                return;
            }
            pendingUpdate.current = true;
            requestAnimationFrame(()=>{
                pendingUpdate.current = false;
                onViewportUpdate(getCallbackValue(supportsVisualViewport, e));
            });
        };
        window.visualViewport.addEventListener('scroll', viewportHandler);
        window.visualViewport.addEventListener('resize', viewportHandler);
        return ()=>{
            window.visualViewport.removeEventListener('scroll', viewportHandler);
            window.visualViewport.removeEventListener('resize', viewportHandler);
        };
    }, [
        pendingUpdate,
        onViewportUpdate,
        supportsVisualViewport,
        enabled
    ]);
    // Fake it for older browsers, not a full polyfill because it doesn't deal with
    // scale or the offsets
    useEffect(()=>{
        if (supportsVisualViewport || !enabled) {
            return;
        }
        onViewportUpdate(getCallbackValue(supportsVisualViewport));
        const viewportHandler = (e)=>{
            if (pendingUpdate.current) {
                return;
            }
            pendingUpdate.current = true;
            requestAnimationFrame(()=>{
                pendingUpdate.current = false;
                onViewportUpdate(getCallbackValue(supportsVisualViewport));
            });
        };
        window.addEventListener('scroll', viewportHandler);
        window.addEventListener('resize', viewportHandler);
        return ()=>{
            window.removeEventListener('scroll', viewportHandler);
            window.removeEventListener('resize', viewportHandler);
        };
    }, [
        enabled,
        onViewportUpdate,
        supportsVisualViewport
    ]);
}

//# sourceMappingURL=useVisualViewport.js.map